<template>
  <SportDiscoverTeamsOrganize sport="football" />
</template>

<script>
import SportDiscoverTeamsOrganize from "@/routes/match_hub/shared/SportDiscoverTeamsOrganize.vue";

export default {
  name: "FootballOrganizeMatch",
  components: { SportDiscoverTeamsOrganize },
};
</script>
